import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, MessageCircle } from "lucide-react";
import { externalLinkHandler } from "../lib/openExternal";

const STORES = [
    {
        name: "Copiapó",
        address: "Bernardo O'Higgins 443, Local 12",
        hours: "Lun-Sáb 10:00 – 20:00",
        maps: "https://www.google.com/maps/search/?api=1&query=Bernardo+O%27Higgins+443+local+12+Copiap%C3%B3+Chile",
    },
    {
        name: "La Serena",
        address: "Brasil 591, Local 4",
        hours: "Lun-Sáb 9:00 – 19:00",
        maps: "https://www.google.com/maps/search/?api=1&query=Brasil+591+local+4+La+Serena+Chile",
    },
];

const IG_URL = "https://instagram.com/ladulceriamexicana30";
const FB_URL = "https://facebook.com/ladulceriamexicana30";
const WA_URL = "https://wa.me/56998091369";

export default function Footer() {
    return (
        <footer className="mt-24 bg-cocoa text-white">
            <div className="fiesta-stripes h-1.5 w-full" />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div>
                    <div className="flex items-center gap-3 mb-3">
                        <img
                            src="/logo.png"
                            alt="La Dulcería Mexicana"
                            className="w-14 h-14 rounded-2xl object-cover shadow-md ring-2 ring-mexyellow"
                        />
                        <div>
                            <div className="font-display font-semibold">La Dulcería</div>
                            <div className="text-mexyellow text-xs uppercase tracking-widest">Mexicana</div>
                        </div>
                    </div>
                    <p className="text-sm text-white/70 mb-4">
                        Los auténticos sabores de México, directo a tu puerta. Dulces enchilados, gomitas, chocolates y más.
                    </p>
                    <div className="flex items-center gap-3">
                        <a
                            data-testid="footer-instagram-link"
                            href={IG_URL}
                            onClick={externalLinkHandler(IG_URL)}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Instagram @ladulceriamexicana30"
                            className="w-10 h-10 rounded-2xl bg-gradient-to-br from-marigold to-mexred flex items-center justify-center hover:scale-110 transition-transform shadow-md"
                        >
                            <Instagram className="w-5 h-5 text-white" />
                        </a>
                        <a
                            data-testid="footer-facebook-link"
                            href={FB_URL}
                            onClick={externalLinkHandler(FB_URL)}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Facebook ladulceriamexicana30"
                            className="w-10 h-10 rounded-2xl bg-[#1877F2] flex items-center justify-center hover:scale-110 transition-transform shadow-md"
                        >
                            <Facebook className="w-5 h-5 text-white" />
                        </a>
                        <a
                            data-testid="footer-whatsapp-link"
                            href={WA_URL}
                            onClick={externalLinkHandler(WA_URL)}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="WhatsApp +56 9 9809 1369"
                            className="w-10 h-10 rounded-2xl bg-[#25D366] flex items-center justify-center hover:scale-110 transition-transform shadow-md"
                        >
                            <MessageCircle className="w-5 h-5 text-white" />
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="font-display font-semibold mb-3 text-mexyellow">Tienda</h4>
                    <ul className="space-y-2 text-sm text-white/80">
                        <li><Link to="/productos" className="hover:text-mexyellow transition-colors">Catálogo</Link></li>
                        <li><Link to="/promociones" className="hover:text-mexyellow transition-colors">Promociones</Link></li>
                        <li><Link to="/productos?categoria=Packs" className="hover:text-mexyellow transition-colors">Packs</Link></li>
                        <li><Link to="/login" className="hover:text-mexyellow transition-colors">Mi cuenta</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold mb-3 text-mexyellow">Nuestros locales</h4>
                    <ul className="space-y-3 text-sm text-white/80">
                        {STORES.map((s) => (
                            <li key={s.name}>
                                <a
                                    data-testid={`footer-store-${s.name}`}
                                    href={s.maps}
                                    onClick={externalLinkHandler(s.maps)}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="flex items-start gap-2 hover:text-mexyellow transition-colors group"
                                >
                                    <MapPin className="w-4 h-4 mt-0.5 text-marigold shrink-0 group-hover:scale-110 transition-transform" />
                                    <div>
                                        <div className="font-semibold text-white">{s.name}</div>
                                        <div className="text-xs">{s.address}</div>
                                        <div className="text-[11px] text-mexyellow/90 mt-0.5">{s.hours}</div>
                                    </div>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold mb-3 text-mexyellow">Síguenos</h4>
                    <ul className="space-y-2 text-sm text-white/80">
                        <li>
                            <a
                                href={IG_URL}
                                onClick={externalLinkHandler(IG_URL)}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2 hover:text-mexyellow transition-colors"
                            >
                                <Instagram className="w-4 h-4" /> @ladulceriamexicana30
                            </a>
                        </li>
                        <li>
                            <a
                                href={FB_URL}
                                onClick={externalLinkHandler(FB_URL)}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2 hover:text-mexyellow transition-colors"
                            >
                                <Facebook className="w-4 h-4" /> ladulceriamexicana30
                            </a>
                        </li>
                        <li>WhatsApp: +56 9 9809 1369</li>
                        <li>Teléfono: +56 9 9785 5364</li>
                        <li className="pt-1 text-xs text-mexyellow font-semibold uppercase tracking-widest">Horarios</li>
                        <li>Copiapó: Lun-Sáb 10:00 – 20:00</li>
                        <li>La Serena: Lun-Sáb 9:00 – 19:00</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10 py-4 text-center text-xs text-white/60 px-4">
                © {new Date().getFullYear()} <span className="font-semibold text-white">LaDulceríaMexicana30</span>
                <span className="mx-2 text-mexyellow">·</span>
                <span className="uppercase tracking-widest text-mexyellow">El sabor mexicano en tu paladar</span>
                <span className="mx-1">🌶️</span>
            </div>
        </footer>
    );
}
